
//Copyright (c) 2022 Panshak Solomon

import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import SnackbarProvider from 'react-simple-snackbar'
import Invoice from './components/Invoice/Invoice';
import Invoices from './components/Invoices/Invoices';
import InvoiceDetails from './components/InvoiceDetails/InvoiceDetails';
import InvoiceDetailsPrint from './components/InvoiceDetails/InvoiceDetailsPrint';
import Inventory from './components/Inventory/inventory';
import Inventories from './components/Inventories/Inventories';
import InventoryDetails from './components/InventoryDetails/inventoryDetails';
import ClientList from './components/Clients/ClientList';
import VendorList from './components/Vendors/VendorList';
import MetalList from './components/Metals/MetalList';
import NavBar from './components/NavBar/NavBar';
import Users from './components/Users/Users';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Settings from './components/Settings/Settings';
import Forgot from './components/Password/Forgot';
import Reset from './components/Password/Reset';
import Reports from './components/Reports/Reports';
import SalesReport from './components/Reports/SalesReport';
import InventoryReport from './components/Reports/InventoryReport';
import VendorReport from './components/Reports/VendorReport';
import CustomerReport from './components/Reports/CustomerReport';
function App() {

  
  const user = JSON.parse(localStorage.getItem('profile'))

  return (
    <div>
      <BrowserRouter>

      <SnackbarProvider>
      {user && window.location.pathname.indexOf('/invoiceprint/')==-1 && <NavBar />} 
      {window.location.pathname.indexOf('/invoiceprint/')==-1 && <Header />} 
      <Switch>
        <Route path="/" exact component={Dashboard} />
        <Route path="/invoice" exact component={Invoice} />
        <Route path="/edit/invoice/:id" exact component={Invoice} />
        <Route path="/invoiceprint/:id" exact component={InvoiceDetailsPrint} />
        <Route path="/invoice/:id" exact component={InvoiceDetails} />
        <Route path="/invoices" exact component={Invoices} />
        <Route path="/inventory" exact component={Inventory} />
        <Route path="/edit/inventory/:id" exact component={Inventory} />
        <Route path="/inventory/:id" exact component={InventoryDetails} />
        <Route path="/inventories" exact component={Inventories} />
        <Route path="/login" exact component={Login} />
        <Route path="/users" exact component={Users} />
        <Route path="/settings" exact component={Settings} />
        <Route path="/dashboard" exact component={Dashboard} />
        <Route path="/customers" exact component={ClientList} />
        <Route path="/vendors" exact component={VendorList} />
        <Route path="/reports" exact component={Reports} />
        <Route path="/salesReport" exact component={SalesReport} />
        <Route path="/inventoryReport" exact component={InventoryReport} />
        <Route path="/vendorReport" exact component={VendorReport} />
        <Route path="/customerReport" exact component={CustomerReport} />
        <Route path="/metal" exact component={MetalList} />
        <Route path="/forgot" exact component={Forgot} />
        <Route path="/reset/:token" exact component={Reset} />
        <Redirect exact from="/new-invoice" to="/invoice" />

      </Switch>
      {window.location.pathname.indexOf('/invoiceprint/')==-1 && <Footer />} 
      </SnackbarProvider>
      </BrowserRouter>
    </div>
    );
}

export default App;
